import { useGlobal } from '../hooks/useGlobal';
import { ReactNode, useMemo } from 'react';
import { CSSVarThemeProvider, findClosestColor, theme } from 'rwl-ui';

export const BrandProvider = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element | null => {
    const { config } = useGlobal();

    const colorOverrides = useMemo(() => {
        if (!config?.account) {
            return;
        }
        if (config.account.mapSettings?.color) {
            return {
                primary: findClosestColor(config.account.mapSettings.color),
            };
        }

        return {};
    }, [config]);
    return (
        <>
            <CSSVarThemeProvider
                theme={theme}
                global={true}
                colorOverrides={colorOverrides}
            />
            {children}
        </>
    );
};
